import { FC, memo } from 'react';
import OutgoingCallsUploadPopup from './OutgoingCallsUploadPopup';

const OutgoingCallsUploadPopupAdapter: React.FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => {
  return <OutgoingCallsUploadPopup open={open} onCancel={onClose} />;
};

export default memo(OutgoingCallsUploadPopupAdapter);
